module.exports = "/_next/static/images/1202fbfd0d0f3f423dbb943418b1ed62-for-who-xs.jpg";